import React from "react";
import styled from "react-emotion";
import { Icon } from "antd";

const Container = styled("div")({
  width: "728px",
  height: "90px"
});

const Title = styled("div")({
  color: "#585858",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "12px"
});

const Ad = styled("div")({
  wordBreak: "break-word",
  display: "flex",
  border: "1px solid #eee",
  height: "100%"
});

const AdHeadline = styled("div")(props => ({
  width: "65%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
  img: {
    position: "absolute",
    left: 0,
    width: "172px",
    height: "100%"
  },
  section: {
    height: "100%",
    position: "absolute",
    left: "200px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center"
  },
  h1: {
    textAlign: "left",
    marginLeft: "65px",
    paddingTop: "8px",
    fontWeight: 700
  },
  ".horizontal-logo-ad": {
    width: "50px",
    height: "50px",
    display: props.img ? "inline" : "none",
    position: "absolute"
  }
}));

const AdDescription = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "35%",
  height: "100%",
  position: "relative"
});

const Text = styled("div")(props => ({
  textAlign: "left",
  position: "absolute",
  left: props.img ? "0px" : "10px",
  fontSize: props.small ? "12px" : "14px",
  maxWidth: "170px"
}));

const IconWrapper = styled("div")({
  position: "absolute",
  marginRight: "10px",
  right: 5
});

const ImageAd_728 = ({ parentId, previewObject, download }) => {
  return (
    <Container>
      <Title className="title">
        Example of your image ad at 728x90
        <Icon
          type="download"
          onClick={() =>
            download(
              parentId,
              {
                id: "horizontalAd_image",
                marginLeft: "0px",
                marginTop: "0px"
              },
              {
                className: ".horizontal-image-ad",
                width: "172px",
                marginTop: "0px",
                marginLeft: "0px"
              },
              {
                className: ".horizontal-logo-ad",
                width: "50px",
                height: "50px"
              },
              ".icon"
            )
          }
          title="Download"
          style={{ fontSize: "18px", marginLeft: "10px" }}
        />
      </Title>
      <Ad id="horizontalAd_image">
        <AdHeadline img={previewObject.selectedLogo.url}>
          <img
            src={previewObject.selectedImage.url}
            alt="banner-ad"
            className="horizontal-image-ad"
          />
          <section>
            <img
              className="horizontal-logo-ad"
              src={previewObject.selectedLogo.url}
              alt="banner-ad"
            />
            <h1> {previewObject.headline}</h1>
          </section>
        </AdHeadline>
        <AdDescription>
          <Text
            small={previewObject.description.length >= 45}
            img={previewObject.selectedLogo.url}
          >
            <span>{previewObject.description}</span>
          </Text>
          <IconWrapper>
            <img
              src={require("../../../images/icons8-next-page-50.png")}
              alt="icon"
              style={{ width: "40px" }}
            />
          </IconWrapper>
        </AdDescription>
      </Ad>
    </Container>
  );
};

export default ImageAd_728;
